module.exports = __webpack_public_path__ + "static/manhattan-bridge-2aa062d1b2bdb99e0fa7aa9d77763ad7.jpg";